export default "__VITE_ASSET__4542985d__"